/* =========================================================================
   "Did You Know?" scheduling — pure logic, unit-tested.
   v1.1.0 rhythm: an interval-of-5 cadence with a per-game cap, replacing the
   old fixed [7, 22] thresholds. A fact wants to fire every 5 cumulative
   questions (5, 10, 15, 20, …), up to DYK_MAX_PER_GAME times.

   The `>=` shape preserves deferral-on-collision: a reveal consumed by a
   mid-round break (cumulative 5/14/22/31/41) or the guest register prompt
   (cumulative 20) returns early WITHOUT incrementing firedCount, so the fact
   simply fires on the next reveal instead of being lost. Theo frames each card
   via the registry 'dyk' moment line around triggerDidYouKnow.
   ========================================================================= */
export const DYK_INTERVAL = 5;
export const DYK_MAX_PER_GAME = 4;

export function dykShouldFire(cumulativeAnswered: number, firedCount: number): boolean {
  return firedCount < DYK_MAX_PER_GAME && cumulativeAnswered >= (firedCount + 1) * DYK_INTERVAL;
}
